import { Outlet } from "react-router-dom";

import { logout } from "@/api";
import { Button } from "@/components/ui/button";

/**
 * Persistent chrome around the authenticated pages — just a top bar with a
 * logout control. Per-page headers (title, polling indicator) stay inside
 * each page component; this is outer chrome, not a replacement for them.
 */
export function AppShell(): JSX.Element {
  const handleLogout = async () => {
    try {
      await logout();
    } finally {
      // Hard navigation, not client-side routing: a fresh load re-runs the
      // QueryCache's 401 check against a now-cookie-less browser, and
      // there's nothing in app state worth preserving across logout.
      window.location.assign("/login");
    }
  };

  return (
    <div className="min-h-screen bg-background text-foreground">
      <div className="border-b">
        <div className="container flex items-center justify-between py-3">
          <span className="text-sm font-medium">DGP Dashboard</span>
          <Button variant="ghost" size="sm" onClick={handleLogout}>
            Log out
          </Button>
        </div>
      </div>
      <Outlet />
    </div>
  );
}
